export default __webpack_public_path__ + "156098213288d061e6d315fd7a8a07fc.png";